"use strict";

exports.__esModule = true;
exports.useToolbarPageNav = void 0;

var _react = require("react");

var _uuid = require("uuid");

const useToolbarPageNav = ({
  currentPage,
  numPages,
  onPageNumberChange
}) => {
  const pageInputRef = (0, _react.useRef)();
  const pageEditRef = (0, _react.useRef)();
  const tooltipId = (0, _uuid.v4)();
  const [page, setPage] = (0, _react.useState)(currentPage);
  const gotoNextPage = (0, _react.useCallback)(() => {
    if (currentPage < numPages) {
      const nextPage = currentPage + 1;
      setPage(nextPage);
      onPageNumberChange(nextPage);
    }
  }, [currentPage]);
  const gotoPreviousPage = (0, _react.useCallback)(() => {
    if (currentPage > 1) {
      const previousPage = currentPage - 1;
      setPage(previousPage);
      onPageNumberChange(previousPage);
    }
  }, [currentPage]);
  const maxPages = numPages < 10 ? 1 : numPages < 100 ? 2 : 3;
  (0, _react.useEffect)(() => {
    if (page !== currentPage) {
      setPage(currentPage);
    }
  }, [currentPage]); // method to ignore any keypresses that aren't numbers

  const handleInputKeyDown = (0, _react.useCallback)(event => {
    event = event || window.event;
    var charCode = event.which || event.keyCode;

    if (charCode === 13) {
      event.target.blur();
    }

    if (charCode < 40) {
      return;
    }

    var charStr = String.fromCharCode(charCode);

    if (/[^0-9]/i.test(charStr)) {
      event.preventDefault();
    } else if (numPages < 10 && event.target.value.length > 1) {
      event.preventDefault();
    } else if (numPages < 100 && event.target.value.length > 2) {
      event.preventDefault();
    } else if (charStr.length > 3) {
      event.preventDefault();
    }
  }, []);
  const handleInputChange = (0, _react.useCallback)(event => {
    setPage(event.target.value);
  }, []);
  const handleInputBlur = (0, _react.useCallback)(event => {
    let value = event.target.value.replace(/[^0-9]/g, '');

    if (value.length === 0) {
      onPageNumberChange(page);
      return;
    }

    value = parseInt(value, 10);

    if (value < 1 || value > numPages) {
      setPage(value);
      return;
    }

    onPageNumberChange(value);
  }, []);

  const focusInput = () => {
    pageInputRef.current.focus();
  };

  const pageEditNavClass = numPages >= 100 ? `page-nav-edit page-nav-edit--lg` : `page-nav-edit`;
  return {
    page,
    gotoNextPage,
    gotoPreviousPage,
    maxPages,
    handleInputKeyDown,
    handleInputChange,
    handleInputBlur,
    focusInput,
    pageInputRef,
    pageEditRef,
    tooltipId,
    pageEditNavClass
  };
};

exports.useToolbarPageNav = useToolbarPageNav;